import { render, staticRenderFns } from "./myCollectionMore.vue?vue&type=template&id=3ee1999f&scoped=true"
import script from "./myCollectionMore.vue?vue&type=script&lang=js"
export * from "./myCollectionMore.vue?vue&type=script&lang=js"
import style0 from "./myCollectionMore.vue?vue&type=style&index=0&id=3ee1999f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee1999f",
  null
  
)

export default component.exports